import { usePlaylists } from '@/hooks/api/usePlaylists';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { NumberCompactFormat } from '@/components/common/NumberCompactFormat';
import ReactTimeAgo from 'react-time-ago';
import { Features } from '@/components/features/top/Features';
import { isMobile, isTablet } from 'react-device-detect';
import BANNER_SRC from '@/assets/images/halloween2026_banner.png';

const IFRAME_SRC = 'https://www.cityheaven.net/tokyo/diarytop/netatop/neta-46969/?heaventv&pcmode=sp';
const BANNER_URL = 'https://www.cityheaven.net/tokyo/diarytop/netatop/neta-46969/?pcmode=sp';
// const IFRAME_SRC = 'https://www.cityheaven.net/hokkaido/diarytop/netatop/neta-46652/?heaventv&pcmode=sp';
const IFRAME_ORIGIN = new URL(IFRAME_SRC).origin;

export const Playlists = () => {
  const { data: playlists } = usePlaylists();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState<number | null>(null);

  // iframe内のページから送られてくる高さに合わせてiframeの高さを変更する
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== IFRAME_ORIGIN) return;
      if (event.source !== iframeRef.current?.contentWindow) return;
      if (event.data?.type !== 'resize_iframe') return;

      const height = Number(event.data.height);
      if (Number.isFinite(height) && height > 0) {
        // console.log('iframe height:', height);
        setIframeHeight(height);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <>
      {playlists?.map((playlist, idx) => (
        <React.Fragment key={playlist.id}>
          <section className={idx === 0 ? 'top-movies xl' : 'top-movies'}>
            <h2 className="section-title">{playlist.name}</h2>
            <Swiper slidesPerView={'auto'} centeredSlides={false}>
              {playlist.channel_posts.map((cp) => (
                <SwiperSlide key={`${playlist.id}-${cp.id}`}>
                  <Link to={`/channels/${cp.channel_outline.cid}/channel_posts/${cp.id}`} className="swiper-slide">
                    <div className="cover-wrapper">
                      <img src={cp.cover_image_url} className="cover" />
                      <span className="time">{cp.channel_post_movie.duration_label}</span>
                    </div>

                    <div className="content">
                      <h5>{cp.title}</h5>
                      <ul className="meta">
                        <li>
                          <NumberCompactFormat val={cp.movie_plays_count} />
                          回視聴
                        </li>
                        <li>
                          <ReactTimeAgo date={new Date(cp.posted_at)} locale="ja" />
                        </li>
                      </ul>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>

          {isMobile && idx === 0 && (
            <iframe
              className="cp-iframe"
              ref={iframeRef}
              src={IFRAME_SRC}
              style={iframeHeight ? { height: iframeHeight } : undefined}
              scrolling="no"
            ></iframe>
          )}

          {!isMobile && idx === 0 && (
            <section className="covers">
              <Link to={BANNER_URL} className="cp-banner" target="_blank" rel="noopener noreferrer">
                <img src={BANNER_SRC} />
              </Link>
            </section>
          )}
        </React.Fragment>
      ))}
    </>
  );
};
